import React, { Component } from 'react';

class ClientSelection extends Component {
    constructor(props, context) {
        super(props, context);
    }

    onSelectClient(client) {
        let { username } = this.props.location.query;
        this.props.onSubmit(client, username);
    }

    render() {
        return (
            <div>
                <h2 className="text-center m-t-5 m-b-20">Select Provider</h2>
                {
                    this.props.auth.clients.map(function (client) {
                        return (
                            <div className="card-slim" key={client} onClick={this.onSelectClient.bind(this, client)}>
                                <a href="#" className={"client-logo client-logo-" + client.toLowerCase()} />
                            </div>
                        );
                    }.bind(this))
                }
            </div>
        );
    }
}

export default ClientSelection;


// WEBPACK FOOTER //
// ./app/auth/components/clientSelection.js